/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import CustomCheckbox from "../../atoms/CustomCheckbox";
import Buttons from "../../atoms/Buttons";
import "./bank-mandate-confirm-details.scss";
import { RA_STEPS_IDENTIFIERS } from "../../constants/constants";
import { useSelector } from "react-redux";

const BankMandateConfirmDetails = (props) => {
  const { bankDetails } = useSelector(
    (state) => state.retirementApplication, // eslint-disable-line
  );
  const { editingPage, setEditingPage } = props;
  const { setBankMandateConfirmationChecked } = props;
  const [confirmAthorize, setConfirmAthorize] = useState(false);
  const handleBack = () => {
    props.makeInitialStepper(false, 42, { isBankMandate: true }, true);
  };
  const handleContinue = () => {
    props.nextStepIndentifier(
      RA_STEPS_IDENTIFIERS.BANK_MANDATE_CONFIRM,
      {
        bankDetails,
      },
      "",
      editingPage,
    );
    setEditingPage("");
  };
  return (
    <>
      <Card className="application-step">
        <Card.Body className="bank-mandate-confirm-details">
          <Row>
            <Col md={12} className="mb-fourty">
              <p className="guidance">
                Please confirm bank details are correct
              </p>
            </Col>
          </Row>

          {bankDetails?.swift ? (
            <Row className="d-flex justify-content-between">
              <div className="bank-details">
                <div className="decision justify-content-between">
                  <div>SWIFT:</div>
                  <span className="fw-bold">{bankDetails?.swift}</span>
                </div>
                <div className="decision justify-content-between">
                  <div>Account holder&apos;s name:</div>
                  <span className="fw-bold">{bankDetails?.accountName}</span>
                </div>
                <div className="decision justify-content-between">
                  <div>Account number:</div>
                  <span className="fw-bold">{bankDetails?.accountNumber}</span>
                </div>
              </div>
            </Row>
          ) : (
            <Row className="d-flex justify-content-between">
              <div className="bank-details">
                <div className="decision justify-content-between">
                  <div>Sort code:</div>
                  <span className="fw-bold">
                    {bankDetails?.sortCodeVal?.match(/.{1,2}/g)?.join("-") ||
                      ""}
                  </span>
                </div>
                <div className="decision justify-content-between">
                  <div>Account number:</div>
                  <span className="fw-bold">{bankDetails?.accountNumber}</span>
                </div>
                <div className="decision justify-content-between">
                  <div>Account holder&apos;s name:</div>
                  <span className="fw-bold">{bankDetails?.accountName}</span>
                </div>
                {bankDetails?.societyCode && (
                  <div className="decision justify-content-between">
                    <div>Building society code:</div>
                    <span className="fw-bold">{bankDetails?.societyCode}</span>
                  </div>
                )}
              </div>
            </Row>
          )}
          <Row className="confirm-details">
            <Col md={12} className="bg-text">
              <div className="check-box">
                <CustomCheckbox
                  name="pension-wise-guidance"
                  label="I authorise you to pay my pension and any lump sum into the bank or building society shown above."
                  variantName="custom-checkbox mt-3"
                  onChange={() => {
                    setBankMandateConfirmationChecked(true);
                    setConfirmAthorize(true);
                  }}
                />
              </div>
            </Col>
            <Col md={6}></Col>
          </Row>

          <div className="footer-btn-container">
            <Buttons
              handleClick={handleBack}
              className="secondary back-btn"
              name="Back"
            />

            <Buttons
              handleClick={() => handleContinue()}
              className="primary"
              name="Continue"
              disabled={confirmAthorize ? false : true}
            />
          </div>
        </Card.Body>
      </Card>
    </>
  );
};
export default BankMandateConfirmDetails;
